import React from "react";
import "./contact-widget.styles.scss";

const ContactWidget = (data) => {
  return (
    <div className="contact-container">
      {/* #RP - Task 46 - Bind data to ContactUs Form in Front-End. */}
      <p className="title">{data.data.SideTitle}</p>
      <p className="content">{data.data.SideContent}</p>
    </div>
  );
};

export default ContactWidget;
